// extracted by mini-css-extract-plugin
export default {"target-definition":"WordList_target-definition__gE0cG","scroll":"WordList_scroll__KEF7B","pointer":"WordList_pointer__Sc1AN"};